import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogService } from '../../services/confirm.dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  constructor(public confirmDialog: ConfirmDialogService) {}

  confirm(): void {
    this.confirmDialog.close(true);
  }

  cancel(): void {
    this.confirmDialog.close(false);
  }
}